<template>
  <div class='border-[1px] border-gray-100 w-full h-[1px] mr-2'></div>
</template>
<script>
export default {
  name: 'SplitBar',
  setup () {
  }
}
</script>
